/*  eslint-disable */

import React from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import { NewProps } from './types';
import { ListCheckbox } from './styles';

const IndeterminateCheckbox = ({
  items,
  getIdActivity,
  getTagActivity,
  getTahCheckbox,
}: NewProps) => {
  const [itemsValue, setItemsValue] = React.useState(items);
  const [checkId, setCheckId] = React.useState(items);

  function selectChecksIds() {
    var allchecks: any = [];
    var allcheckLabel: any = [];
    var allcheckTag: any = [];
    for (let i = 0; i < items.length; i += 1) {
      for (let l = 0; l < items[i].equipments.length; l += 1) {
        if (items[i].equipments[l].checked == true) {
          allchecks.push(items[i].equipments[l].id);
          allcheckLabel.push(items[i].equipments[l].description);
          allcheckTag.push(items[i].equipments[l].tag);
        }
      }
    }
    allchecks = allchecks.map(check => check);
    setCheckId(allchecks);
    getIdActivity(allchecks);
    getTagActivity(allcheckLabel);
    getTahCheckbox(allcheckTag);
  }

  const handleChange1 = (i: number, event) => {
    items[i].equipments.map(item => (item.checked = event.target.checked));

    items[i].equipments.map(option => {
      return Object.assign(option, {
        checked: (items[i].checked = event.target.checked),
      });
    });
    setItemsValue([...itemsValue]);
    selectChecksIds();
  };

  const handleChecked = (indexSpe: number, indexWtg: number) => {
    items[indexSpe].equipments[indexWtg].checked =
      !items[indexSpe].equipments[indexWtg].checked;
    setItemsValue([...itemsValue]);
    selectChecksIds();
  };

  return (
    <>
      <ListCheckbox>
        {items.map((pai, i) => (
          <div className="container" key={pai.spe}>
            <FormControlLabel
              className="labelOne"
              label={pai.spe}
              control={
                <Checkbox
                  size="small"
                  checked={pai.checked}
                  onChange={e => handleChange1(i, e)}
                />
              }
            />

            {
              <Box>
                {pai.equipments.map((child, id) => (
                  <FormControlLabel
                    key={id}
                    className="labelTwo"
                    label={child.tag}
                    control={
                      <Checkbox
                        size="small"
                        className="childrens"
                        checked={child.checked}
                        onChange={() => handleChecked(i, id)}
                      />
                    }
                  />
                ))}
              </Box>
            }
          </div>
        ))}
      </ListCheckbox>
    </>
  );
};

export default IndeterminateCheckbox;
